import Modal from 'react-modal';
import PropTypes from 'prop-types';
import "../../../styles/AdminPage.css";
import React , {useEffect, useState} from 'react';
import { createPronoun, updatePronoun } from '../../../api/admin/AdminSettingsAPI';
import AdminSettingsEditModal from './AdminSettingsEditModal';
import DropdownModalContent from './EditDropdownModal';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const EditPronounModal = ({ isOpen, onClose, isAdding, item, setItems }) => {    
    const [dropdownValue, setDropdownValue] = useState("");
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (!isAdding && item) {
            setDropdownValue(item.dropdownValue);
            setPosition(item.position);
        }
    }, [isAdding, item]);

    const modalTitle = isAdding ? "Add Pronoun" : "Edit Pronoun";

    const handleConfirm = async () => {
        let data;
        
        if (isAdding) {
            data = {
                dropdownValue,
                position
            };

            try {
                toast.loading("Creating Pronoun...");
                const response = await createPronoun(data);
                setTimeout(async () => {
                    if (response.ok) {
                        toast.dismiss();
                        try {
                            const newData = await response.json();
                            toast.success("Pronoun created!");
                            setItems((prev) => [...(prev ?? []), newData]);
                            onClose();
                        } catch (jsonError) {
                            console.error("Error parsing JSON:", jsonError);
                            toast.error("Error parsing server response.");
                        }
                    } else {
                        toast.dismiss();
                        console.log("Error creating Pronoun. Status:", response.status);
                        toast.error("Pronoun failed to create. Status: " + response.status);
                    }
                    
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Pronoun:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        } else {
            data = {
                id: item.id,
                dropdownValue: dropdownValue,
                position: position
            };
            try {
                toast.loading("Updaing Pronoun...");
                const response = await updatePronoun(data);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                toast.success("Pronoun updated!");
                                setItems((prev) => (prev ?? []).map(p => p.id === item.id ? data : p));
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error updating Pronoun. Status:", response.status);
                            toast.error("Pronoun failed to create. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Pronoun:", error);
                alert("Something went wrong. Please check your connection and try again.");
            }
        }
    };

    const content = (
        <DropdownModalContent 
            dropdownValue={dropdownValue}
            setDropdownValue={setDropdownValue}
            position={position}
            setPosition={setPosition}
        />
    );

    return (
        <AdminSettingsEditModal
            modalTitle={modalTitle}
            content={content}
            isOpen={isOpen}
            onClose={onClose}
            handleConfirm={handleConfirm}
        />
    );
};

EditPronounModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditPronounModal;